import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { themeVariants } from '../config.js';
import { useAppContext } from '../providers/AppProvider.js';
import { useSelector } from 'react-redux';

// 主题配置映射
const THEME_CONFIG = {
	light: {
		icon: 'sun',
		label: '浅色',
		description: 'Light',
	},
	dark: {
		icon: 'moon',
		label: '深色',
		description: 'Dark',
	},
	auto: {
		icon: 'adjust',
		label: '自动',
		description: 'Auto',
	},
};

const ThemeControlDropdown = ({ dropdownClassName, iconClassName = 'fs-8' }) => {
	const { theme } = useSelector((state) => state.config);
	const { changeTheme } = useAppContext();

	// 获取当前主题图标
	const currentThemeIcon = useMemo(() => {
		return THEME_CONFIG[theme]?.icon || 'adjust';
	}, [theme]);

	// 处理主题切换
	const handleThemeChange = useCallback(
		(colorMode) => {
			if (colorMode && themeVariants.includes(colorMode)) {
				changeTheme(colorMode);
			}
		},
		[changeTheme]
	);

	// 获取主题显示名称
	const getThemeLabel = useCallback((colorMode) => {
		return THEME_CONFIG[colorMode]?.label || colorMode.charAt(0).toUpperCase() + colorMode.slice(1);
	}, []);

	// 获取主题图标
	const getThemeIcon = useCallback((colorMode) => {
		return THEME_CONFIG[colorMode]?.icon || 'adjust';
	}, []);

	return (
		<Dropdown
			navbar={true}
			as='li'
			onSelect={handleThemeChange}
			className={`d-flex align-items-center theme-control-dropdown ${dropdownClassName ?? ''}`}
		>
			<Dropdown.Toggle
				bsPrefix='toggle'
				variant='link'
				className='nav-link dropdown-toggle d-flex align-items-center pe-1'
				title={`当前主题: ${getThemeLabel(theme)}`}
			>
				<FontAwesomeIcon icon={currentThemeIcon} className={iconClassName} />
			</Dropdown.Toggle>

			<Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end mt-2' style={{ zIndex: 9999 }}>
				<div className='bg-white rounded-2 py-2 dark__bg-1000 shadow-lg border-0'>
					{themeVariants.map((colorMode) => {
						const isActive = theme === colorMode;
						return (
							<Dropdown.Item
								key={colorMode}
								active={isActive}
								eventKey={colorMode}
								className={`link-600 fs-10 d-flex align-items-center gap-2 px-3 py-2 ${isActive ? 'bg-body-tertiary' : ''}`}
							>
								<FontAwesomeIcon icon={getThemeIcon(colorMode)} className={isActive ? 'text-primary' : 'text-600'} />
								<span className='me-auto'>{getThemeLabel(colorMode)}</span>
								{isActive && <FontAwesomeIcon icon='check' className='text-primary' />}
							</Dropdown.Item>
						);
					})}
				</div>
			</Dropdown.Menu>
		</Dropdown>
	);
};

ThemeControlDropdown.propTypes = {
	iconClassName: PropTypes.string,
	dropdownClassName: PropTypes.string,
};

export default ThemeControlDropdown;
